/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * Copyright IBM Corp. 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types'
], (React, PropTypes) => {

	return class UserInfoCell extends React.Component {

		static propTypes = {
			displayName: PropTypes.string,
			email: PropTypes.string,
			tenantName: PropTypes.string,
			linkText: PropTypes.string,
			linkAction: PropTypes.function
		}

		render() {
			return (
				<a className='user-info-cell' tabIndex="-1">
					<div className='user-icon'>
						<div className='background'></div>
						<svg className='userIcon' role='img' focusable='false'>
							<use style={{ 'pointer-events': 'none' }} xmlnsXlink='http://www.w3.org/1999/xlink' xlinkHref='#ba_portal-user_24'></use>
						</svg>
					</div>
					<div className='user-info'>
						<ul tabIndex="-1">
							{this.props.displayName && <li className='display-name' tabIndex="-1">{this.props.displayName}</li>}
							{this.props.email && <li className='account-info' tabIndex="-1">{this.props.email}</li>}
							{this.props.tenantName && <li className='account-info' tabIndex="-1">{this.props.tenantName}</li>}
							{this.props.linkText && <li className='account-settings' tabIndex="0" onClick={this.props.linkAction}>{this.props.linkText}</li>}
						</ul>
					</div>
				</a>
			);
		}
	};

});